import { ActionTypeEnum, ResourceTypeEnum } from "@superblocksteam/shared";

export const MANAGE_CUSTOM_AGENT_MODELS = {
  resourceType: ResourceTypeEnum.ORGANIZATION,
  action: ActionTypeEnum.MANAGE,
};
